var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{ref:"pc_common",class:`${_vm.classs} detect_deviece_${_vm.deviceType} state_${_vm.deviceType}`},[_c('HeadBar',{attrs:{"deviceType":_vm.deviceType}}),_vm._t("default"),_c('FootBar',{attrs:{"deviceType":_vm.deviceType}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }